module.exports = __webpack_public_path__ + "img/question.bb14323b.jpg";